import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";
import QuestionCard from "./QuestionCard";

function SetWork() {
  const [subject, setSubject] = useState("");
  const [topic, setTopic] = useState("");
  const [questions, setQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  // Fetch all questions from Firestore on load
  useEffect(() => {
    const fetchQuestions = async () => {
      const snapshot = await getDocs(collection(db, "questions"));
      const all = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setQuestions(all);
    };

    fetchQuestions();
  }, []);

  const handleAdd = (question) => {
    if (!selectedQuestions.some((q) => q.id === question.id)) {
      setSelectedQuestions((prev) => [...prev, question]);
    }
  };

  const handlePreview = (question) => {
    alert(`Previewing question:\n\n${question.question}`);
    // You can replace this with a modal later
  };

  const filteredQuestions = questions.filter(
    (q) =>
      (subject ? q.subject === subject : true) &&
      (topic ? q.topic.toLowerCase().includes(topic.toLowerCase()) : true)
  );

  return (
    <TutorLayout>
      <div style={styles.container}>
        <h1>🛠️ Set Work</h1>
        <p>Select a subject and topic to browse available questions.</p>

        <div style={styles.filterSection}>
          <select
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={styles.select}
          >
            <option value="">All Subjects</option>
            <option value="GCSE Maths">GCSE Maths</option>
            <option value="A-Level Maths">A-Level Maths</option>
            <option value="GCSE French">GCSE French</option>
            <option value="A-Level French">A-Level French</option>
          </select>

          <input
            type="text"
            placeholder="Filter by topic"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.grid}>
          {filteredQuestions.length > 0 ? (
            filteredQuestions.map((question) => (
              <QuestionCard
                key={question.id}
                question={question}
                onAdd={() => handleAdd(question)}
                onPreview={() => handlePreview(question)}
              />
            ))
          ) : (
            <p style={{ marginTop: "2rem", fontStyle: "italic" }}>
              No questions found for this filter.
            </p>
          )}
        </div>

        {selectedQuestions.length > 0 && (
          <div style={styles.selected}>
            <h2>✅ Selected Questions ({selectedQuestions.length})</h2>
            <ul>
              {selectedQuestions.map((q) => (
                <li key={q.id}>{q.question}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </TutorLayout>
  );
}

const styles = {
  container: {
    padding: "2rem",
    fontFamily: "'Poppins', sans-serif",
  },
  filterSection: {
    display: "flex",
    gap: "1rem",
    marginBottom: "1.5rem",
    alignItems: "center",
  },
  select: {
    padding: "0.6rem",
    borderRadius: "8px",
    fontSize: "1rem",
    border: "1px solid #ccc",
    minWidth: "200px",
  },
  input: {
    padding: "0.6rem",
    borderRadius: "8px",
    fontSize: "1rem",
    border: "1px solid #ccc",
    flex: 1,
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1.5rem",
    marginTop: "1rem",
  },
  selected: {
    marginTop: "3rem",
    padding: "1rem",
    backgroundColor: "#f9f9f9",
    border: "1px solid #ddd",
    borderRadius: "8px",
  },
};

export default SetWork;
